/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.DepartmentGoal {
    angular.module('meevo.plugins.departmentGoal', []);
}